export const overloadsSymb = /*#__PURE__*/Symbol();
export const interpretable = program => program;
export const defineFor = _ => () => a => a;
//# sourceMappingURL=index.mjs.map